import { createFileRoute } from "@tanstack/react-router";

import { SKUStoreVariantsPage } from "@/features/SKUStore/SKUStoreVariantsPage";

export const Route = createFileRoute(
  "/_auth/sku-store/$siteId/$skuId/variants",
)({
  component: SKUStoreVariantsPage,
});
